import { useEffect, useMemo, useState } from "react";
import { Form } from "react-bootstrap";

import { InfoToolTip } from "../infoToolTip";

export interface RadioButtonType {
	id?: any;
	label: string;
	value: any;
	tooltip?: any;
}

const FieldRadioButton = ({
	radio,
	id,
	name,
	setValue,
}: {
	radio: RadioButtonType;
	id: number;
	name: string;
	setValue: any;
}) => {
	useEffect(() => {
		setValue(radio.value);
	}, []);

	const compId = `rad-${id}`;
	return (
		<Form.Check key={id}>
			<Form.Check.Input
				id={compId}
				data-testid="test-fieldRadioButton"
				// disabled={isDisabled}
				// isInvalid={!!error}
				defaultChecked={id === 0}
				type="radio"
				name={name}
				style={{ marginTop: "3px", borderRadius: "100" }}
				onChange={(e) => {
					setValue(radio.value);
				}}
				// autoFocus={autoFocus}
			/>
			<Form.Check.Label htmlFor={compId} className="ps-1">
				{radio.label}
				{radio.tooltip ? <InfoToolTip tooltip={radio.tooltip} /> : null}
			</Form.Check.Label>
			{/* <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback> */}
		</Form.Check>
	);
};

export const FieldRadioButtons = ({
	isDisabled,
	error,
	fieldData,
	radioData,
	setValue = () => {},
	autoFocus,
	field,
}: {
	isDisabled: boolean;
	error: any;
	fieldData: any;
	radioData: RadioButtonType[];
	setValue: any;
	autoFocus: boolean;
	field: string;
}) => {
	const radioButtons = useMemo(
		() =>
			radioData.map((radio, id) => (
				<FieldRadioButton
					setValue={setValue}
					name={field}
					radio={radio}
					id={id}
				/>
			)),
		[radioData]
	);

	return (
		<Form.Group data-testid="test-fieldRadio">{radioButtons}</Form.Group>
	);
};
